import styled, { keyframes } from "styled-components"
import colors from "../../utils/style/colors.tsx"
import { Transition } from "../../utils/style/transition.tsx"
import LionHead from "../../assets/images/AccueilImg.png"
import ImgServices from "../../assets/images/ImgServices.png"
import ImgProjets from "../../assets/images/ProjetsImg.png"
import { HashLink } from "react-router-hash-link"

const HeroSectionWrapper = styled.div`
    background-color: ${colors.light_pink};
    display: flex;
    justify-content: space-between;
    padding: 200px 10% 5%;

    ${({ inversed }) =>
        inversed &&
        `
        flex-direction: row-reverse;
    `}


    @media (max-width: 768px) {
        padding: 130px 10% 5%;
        flex-direction: column;
    }
`

// Animation de flottaison
const float = keyframes`
    0%, 100% {
        transform: translateY(5px);
    }
    50% {
        transform: translateY(-5px);
    }
`

const ImgWrapper = styled.div`
    width: 33%;
    text-align: center;
    display: flex;
    align-items: center;
    animation: ${float} 3s ease-in-out infinite;

    @media (max-width: 768px) {
        margin-top: 10%;
        width: 100%;
        justify-content: center;
    }
`

// Prevent unknown props from being passed to the DOM
const Img = styled.img.withConfig({
    shouldForwardProp: (prop) => !["isaccueil"].includes(prop),
})`
    border: solid 7px ${colors.black};
    box-shadow: 7px 7px ${colors.black};
    border-radius: 20px;
    width: 100%;

    ${({ isaccueil }) =>
        isaccueil &&
        `
        padding: 5%;
    `}

    ${({ isaccueil }) =>
        !isaccueil &&
        `
        width: 105%;
    `}

    @media (max-width: 768px) {
        border: solid 5px ${colors.black};
        box-shadow: unset;
         ${({ isaccueil }) =>
            isaccueil &&
            `
            width: 45%;
        `}

        ${({ isaccueil }) =>
            !isaccueil &&
            `
            width: 55%;
        `}
    }
`

const Title = styled.h1`
    padding-right: 10%;
    font-weight: 100;
    color: ${colors.h1_red};
    font-size: 50px;

    @media (max-width: 768px) {
        font-size: 24px;
        padding-right: 0;
        text-align: center;
    }
`

const TextWrapper = styled.div`
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (max-width: 768px) {
        width: 100%;
    }
`

const Text = styled.p`
    font-family: "Inter", sans-serif;
    font-size: 22px;
    margin: 0;

    @media (max-width: 768px) {
        font-size: 16px;
        text-align: center;
    }
`

const ButtonWrapper = styled.div`
    margin-top: 10%;
    display: flex;
    align-items: center;

    @media (max-width: 768px) {
        margin-top: 5%;
        justify-content: center;
    }
    
`

const Button = styled(HashLink)`
    padding: 10px 20px;
    background-color: ${colors.dark_red};
    color: ${colors.white};
    border: solid 3px ${colors.black};
    box-shadow: 4px 4px ${colors.black};
    border-radius: 20px;
    font-size: 18px;
    cursor: pointer;
    margin-right: 11%;
    width: 30%;
    height: fit-content;
    font-weight: 600;
    text-decoration: none;
    text-align: center;
    font-family: "Inter", sans-serif;
    transition: all ease 0.3s;

    &:hover{
        transition: all ease 0.3s;
        transform: translate(-5px, -5px);
    }


    @media (max-width: 768px) {
        width: 60%;
        margin-right: 0;
        font-size: 16px;
        padding: 5px 10px;
        font-weight: 500;
    }
`

const linkScroll = () => {
    window.scrollTo({
        behavior: "smooth",
    })
}

function HeroSection({ page }) {
    return (
        <>
            {page === "accueil" && (
                <HeroSectionWrapper>
                    <TextWrapper>
                        <Title>Développeur web Freelance Full-Stack</Title>
                        <Text>
                            Je vous aide à créer votre identité grâce à des cartes
                            de visites, flyers et pourquoi pas un site web adapté à
                            vos besoins.
                        </Text>
                        <ButtonWrapper>
                            <Button onClick={linkScroll} smooth to="/#contact">
                                Contactez moi !
                            </Button>
                        </ButtonWrapper>
                    </TextWrapper>
                    <ImgWrapper>
                        <Img src={LionHead} alt="" isaccueil={page === "accueil"} />
                    </ImgWrapper>
                </HeroSectionWrapper>
            )}

            {page === "services" && (
                <HeroSectionWrapper>
                    <TextWrapper>
                        <Title>Mes services de design et développement web</Title>
                        <Text>
                            Voici différents services que je peux offrir ainsi que ma façon de travailler.
                        </Text>
                        <ButtonWrapper>
                            <Button onClick={linkScroll} smooth to="/#contact">
                                Contactez moi !
                            </Button>
                        </ButtonWrapper>
                    </TextWrapper>
                    <ImgWrapper>
                        <Img src={ImgServices} alt="" isaccueil={page === "accueil"} />
                    </ImgWrapper>
                </HeroSectionWrapper>
            )}

            {page === "projets" && (
                <HeroSectionWrapper>
                    <TextWrapper>
                        <Title>Mes projets professionnels et académiques</Title>
                        <Text>
                            Vous trouverez ici mes différents projets,
                            qu'ils soient professionnels ou réalisés dans
                            un cadre académique
                        </Text>
                        <ButtonWrapper>
                            <Button onClick={linkScroll} smooth to="/#contact">
                                Contactez moi !
                            </Button>
                        </ButtonWrapper>
                    </TextWrapper>
                    <ImgWrapper>
                        <Img src={ImgProjets} alt="" isaccueil={page === "accueil"} />
                    </ImgWrapper>
                </HeroSectionWrapper>
            )}

            <Transition theme={"blanc"} orientation={"180deg"} />
        </>
    )
}

export default HeroSection